import { wpCustomApi } from '@gik/core/api';
import React from 'react';
import { useEffect } from 'react';

interface TaxCalculation {
  subtotal: string;
  subtotal_tax: string;
  tax_rate: string;
}

interface ProductTaxCalculation extends TaxCalculation {
  id: number;
}

export interface ShippingTaxCalculation extends TaxCalculation {
  name: string;
}

interface OrderTaxCalculation {
  shipping: ShippingTaxCalculation[];
  products: {
    items: ProductTaxCalculation[];
    total: TaxCalculation;
  };
}

export default function useOrderTaxCalculation(
  enabled: boolean,
  productIds: number[],
  country = 'US', // pass dummy values if not provided, so that the call still returns shipping info
  state = 'TX',
  city = 'Dallas',
  postcode = '75202',
  street = '101 fake rd'
): OrderTaxCalculation | undefined {
  const [taxCalculation, setTaxCalculation] = React.useState<OrderTaxCalculation>(undefined);
  const productIdsString = productIds.join(', ');
  useEffect(() => {
    if (enabled) {
      (async () => {
        const searchParams = new URLSearchParams();
        searchParams.set('product_ids', productIdsString);
        searchParams.set('country', country);
        searchParams.set('state', state);
        searchParams.set('city', city);
        searchParams.set('postcode', postcode);
        searchParams.set('street', street);
        const result = await wpCustomApi.post('calculate/products', {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: searchParams,
        });
        setTaxCalculation(await result.json());
      })();
    }
  }, [enabled, productIdsString, country, state, city, postcode, street]);
  return taxCalculation;
}
